import { Cell } from '@table-library/react-table-library/table';
import DomainImage from '../../../../../components/DomainImage';
import { showPlatform } from '../../../PromptManager/keys';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.keyword_detail.url_platform_overlap.columns.url'),
        key: 'title',
        data: 'title',
        Component: Cell,
        cellSize: 'minmax(250px, 2.5fr)',
        sortType: 'string',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <strong className="wrap-text">
                    {data}{' '}
                    <a
                        target="_blank"
                        className="link-website d-inline-flex align-items-center justify-content-center"
                        href={item?.url}
                        rel="noreferrer"
                    >
                        <i className="icon-external-link"></i>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.url_platform_overlap.columns.domain'),
        key: 'domain',
        data: 'domain',
        cellSize: 'minmax(180px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.url_platform_overlap.columns.citations'),
        key: 'citiations',
        data: 'citations',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.url_platform_overlap.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_search', { width: '15px' })}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.google_search')}
            </div>
        ),
        key: 'google_search',
        data: 'google_search',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('chat_gpt')}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.chatgpt')}
            </div>
        ),
        key: 'chat_gpt',
        data: 'chat_gpt',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_ai_overview')}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.google_ai_overview')}
            </div>
        ),
        key: 'google_ai_overview',
        data: 'google_ai_overview',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('gemini')}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.gemini')}
            </div>
        ),
        key: 'gemini',
        data: 'gemini',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('google_ai_mode')}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.google_ai_mode')}
            </div>
        ),
        key: 'google_ai_mode',
        data: 'google_ai_mode',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
    {
        label: (
            <div className="ai-table-header">
                {showPlatform('perplexity')}{' '}
                {t('ai_tracking.keyword_detail.url_platform_overlap.columns.perplexity')}
            </div>
        ),
        key: 'perplexity',
        data: 'perplexity',
        Component: Cell,
        renderCell: ({ data }) => {
            return formatNumber(data);
        },
    },
];

function formatNumber(num) {
    return num ? (Number.isInteger(num) ? num : parseFloat(num.toFixed(2))) : '-';
}
